const lbaPagingGrid = angular.module('app.lbaPagingGrid', ['ngTasty']);

lbaPagingGrid.controller('lbaPagingGridCtrl', require('./lbaPagingGridCtrl'));
lbaPagingGrid.controller('lbaDeleteConfirmCtrl', require('./lbaDeleteConfirmCtrl'));
lbaPagingGrid.directive('lbaPagingGrid', require('./lbaPagingGridDir'));

lbaPagingGrid.filter("dateDisplay", require('../../filters/dateFilter.js'));
export default lbaPagingGrid;



// WEBPACK FOOTER //
// ./src/components/lbaPagingGrid/index.js